var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#D6222A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.5C6 3.23478 6.10536 2.98043 6.29289 2.79289C6.48043 2.60536 6.73478 2.5 7 2.5C7.26522 2.5 7.51957 2.60536 7.70711 2.79289C7.89464 2.98043 8 3.23478 8 3.5C8 3.76522 7.89464 4.01957 7.70711 4.20711C7.51957 4.39464 7.26522 4.5 7 4.5C6.73478 4.5 6.48043 4.39464 6.29289 4.20711C6.10536 4.01957 6 3.76522 6 3.5ZM5 6.5C5 6.13125 5.29792 5.83333 5.66667 5.83333H7C7.36875 5.83333 7.66667 6.13125 7.66667 6.5V11.1667H8.33333C8.70208 11.1667 9 11.4646 9 11.8333C9 12.2021 8.70208 12.5 8.33333 12.5H5.66667C5.29792 12.5 5 12.2021 5 11.8333C5 11.4646 5.29792 11.1667 5.66667 11.1667H6.33333V7.16667H5.66667C5.29792 7.16667 5 6.86875 5 6.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRed);
export default __webpack_public_path__ + "static/media/info-red.e5c22109493e41ed3a8742d5de673c15.svg";
export { ForwardRef as ReactComponent };